import setAppSettingsForTenant from "../actions/setAppSettingsForTenant";
import { FlightSettingsPollingService } from "sh-services";
import { orchestrator } from "satcheljs";

export default orchestrator( setAppSettingsForTenant, async actionMessage => {
    // Initialize the polling for the next update
    FlightSettingsPollingService.initTenantPolling(actionMessage.appSettingsClientModel);
});